import { render, staticRenderFns } from "./tag-cmp.vue?vue&type=template&id=6be717c4&scoped=true&functional=true"
import script from "./tag-cmp.vue?vue&type=script&lang=js"
export * from "./tag-cmp.vue?vue&type=script&lang=js"
import style0 from "./tag-cmp.vue?vue&type=style&index=0&id=6be717c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6be717c4",
  null
  
)

export default component.exports